/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Pick_Province_FirstInputs */

const vi_customer_pick_province_first = /** @type {(inputs: Customer_Pick_Province_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn tỉnh trước`)
};

/**

* @param {Customer_Pick_Province_FirstInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_pick_province_first = /** @type {((inputs?: Customer_Pick_Province_FirstInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Pick_Province_FirstInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_pick_province_first(inputs)
});